// extracted by mini-css-extract-plugin
export default {"chat-container":"Chat_chat-container__wymbJ","no-chats-msg-container":"Chat_no-chats-msg-container__RLlCk","no-chats-msg":"Chat_no-chats-msg__fimrP"};